import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Error404Component, PortalsUiModule } from '@portals/ui';
import { NgxLoadingModule } from 'ngx-loading';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { LottieModule } from 'ngx-lottie';
import { HomeComponent } from './home';
import { CloudComponent } from './cloud';
import player from 'lottie-web';
import { HotToastModule } from '@ngneat/hot-toast';

import { WelcomeComponent } from '../../../jotto/app/src/lib/welcome';
import { ThankYouComponent } from '../../../jotto/app/src/lib/thank-you';
import { UploadNoticeComponent } from '../../../jotto/app/src/lib/upload-notice';
import { ChannelFeedComponent } from '../../../jotto/app/src/lib/home/channel-feed';
import { PortalsWordCloudComponent } from './portals-word-cloud';
import { TranslateModule } from '@ngx-translate/core';
import { RedirectComponent } from './redirect/redirect.component';
import { environment } from '@portals/environments';
import { NgxQrcodeStylingModule } from 'ngx-qrcode-styling';
import { MatDialogModule } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { NavbarComponent } from './landing-page/landing-page-components/navbar/navbar.component';
import { TryJottoComponent } from './landing-page/landing-page-components/try-jotto/try-jotto.component';
import { FooterComponent } from './landing-page/landing-page-components/footer/footer.component';
import { QrPanelComponent } from './landing-page/landing-page-components/qr-panel/qr-panel.component';
import { TrustedByCarouselComponent } from './landing-page/landing-page-components/trusted-by-carousel/trusted-by-carousel.component';
import { JottoDescriptionComponent } from './landing-page/landing-page-components/jotto-description/jotto-description.component';
import { CustomerCarouselComponent } from './landing-page/landing-page-components/customer-carousel/customer-carousel.component';
import { SupportPageComponent } from './support-page/support-page.component';
import { ClickScanComponent } from './support-page/click-scan/click-scan.component';
import { LeaveMessageComponent } from './support-page/leave-message/leave-message.component';
import { CollectEmailComponent } from './support-page/collect-email/collect-email.component';
import { CompanyPageComponent } from './company-page/company-page.component';
import { FAQComponent } from './faq/faq.component';
import { SendmessageComponent } from './sendmessage/sendmessage.component';
import { ImageAutoCarouselComponent } from './image-auto-carousel/image-auto-carousel.component';
import { JottoPricingComponent } from './jotto-pricing/jotto-pricing.component';
import { ThankYouAfterComponent } from './thank-you-after/thank-you-after.component';

export function playerFactory() {
	return player;
}

const STATIC_APP_ROUTING: Routes = [
	{ path: '', component: environment.specialRoutes ? LandingPageComponent : HomeComponent, data: { title: 'Let Us Know' } },
	{ path: 'policies/terms', loadChildren: () => import('@portals/features/terms').then((m) => m.PortalsFeaturesTermsModule) },
	{
		path: 'policies/privacy',
		loadChildren: () => import('@portals/features/privacy').then((m) => m.PortalsFeaturesPrivacyModule),
	},
    {
        path: 'policies/tos',
        loadChildren: () => import('@portals/portals/features/stripe').then((m) => m.PortalsFeaturesStripeModule),
    },
	{ path: 'thankyou', component: ThankYouAfterComponent },
	{ path: '404', component: Error404Component },
	{ path: 'support', component: SupportPageComponent, data: { title: 'Support' } },
	{ path: 'send-message', component: SendmessageComponent, data: { title: 'Send Message' } },
	{ path: 'company', component: CompanyPageComponent, data: { title: 'Company' } },
	{ path: 'faq', component: FAQComponent, data: { title: 'FAQ' } },
	{ path: 'pricing', component: JottoPricingComponent, data: { title: 'Pricing' } },
];

const DYNAMIC_APP_ROUTING: Routes = [
	{ path: 'subscribe/:uuid', component: HomeComponent },
	{
		path: 'cloud/:uuid',
		component: CloudComponent,
	},
	{ path: 'channels/:uuid', component: HomeComponent, data: { title: 'Let Us Know' } },
	...STATIC_APP_ROUTING,
	{ path: ':link', component: HomeComponent, data: { title: 'Let Us Know' } },
];

@NgModule({
	imports: [MatSlideToggleModule, FormsModule, MatDialogModule, PortalsUiModule, NgxSkeletonLoaderModule, NgxLoadingModule.forRoot({}), HotToastModule.forRoot(), LottieModule.forRoot({ player: playerFactory }), RouterModule.forChild(environment.specialRoutes ? DYNAMIC_APP_ROUTING : STATIC_APP_ROUTING), TranslateModule, NgxQrcodeStylingModule],
	declarations: [
		HomeComponent,
		WelcomeComponent,
		ThankYouComponent,
		UploadNoticeComponent,
		ChannelFeedComponent,
		RedirectComponent,
		CloudComponent,
		PortalsWordCloudComponent,
		LandingPageComponent,
		NavbarComponent,
		TryJottoComponent,
		FooterComponent,
		QrPanelComponent,
		TrustedByCarouselComponent,
		JottoDescriptionComponent,
		CustomerCarouselComponent,
		SupportPageComponent,
		ClickScanComponent,
		LeaveMessageComponent,
		CollectEmailComponent,
		CompanyPageComponent,
		FAQComponent,
		SendmessageComponent,
		ImageAutoCarouselComponent,
		JottoPricingComponent,
		ThankYouAfterComponent,
	],
	schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA],
})
export class LetUsKnowModule {}
